module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_8003.e7f1e877.png";